import * as React from "react";
const SvgFiRrLawyerWoman = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lawyer-woman_svg__a)">
      <path
        fill="#062147"
        d="M24 18.664V19a2.002 2.002 0 0 1-2.335 1.973C20.681 20.813 20 19.89 20 18.894v-.23l.854-2.42L19 15.896v6.105h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2v-6.48l-1.752-.328.861 2.406v.575h-.013a2.056 2.056 0 0 1-2.466 1.783c-.97-.194-1.63-1.112-1.63-2.101v-.244l1.06-3.379a1.66 1.66 0 0 1 1.886-1.135l2.054.381v-.48a1 1 0 1 1 2 0v.851l2.41.447a1.93 1.93 0 0 1 1.465 1.245l1.124 3.121zM9 14c-4.962 0-9 4.037-9 9a1 1 0 1 0 2 0c0-3.859 3.14-7 7-7a1 1 0 1 0 0-2M.873 12.822c.308-1.306 1.854-7.849 2.026-8.385A6.39 6.39 0 0 1 9 0a6.39 6.39 0 0 1 6.101 4.437c.033.103.133.413 1.303 5.332a1 1 0 1 1-1.945.462c-1.059-4.452-1.233-5.092-1.261-5.182a4.4 4.4 0 0 0-1.675-2.255 6.67 6.67 0 0 1-2.669 3.185A6.67 6.67 0 0 1 5.309 7c-.056 0-.112-.008-.167-.01.444 1.725 1.999 3.009 3.861 3.009a4 4 0 0 0 1.999-.534.999.999 0 1 1 1.002 1.73 6 6 0 0 1-3.001.804 6 6 0 0 1-5.171-2.971c-.344 1.439-.717 3.011-1.01 4.253a1 1 0 0 1-1.946-.458zm3.969-7.865a4.68 4.68 0 0 0 2.952-.674 4.68 4.68 0 0 0 1.863-2.231 4.392 4.392 0 0 0-4.815 2.905"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lawyer-woman_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLawyerWoman;
